import kayak from '@/frame/kayak.js'
import httpUtil from '@/frame/httpUtil.js'
import moment from "moment";
import {MessageBox} from "element-ui";
import global from "@/frame/global";
import store from "@/store/index";
import router from '@/router';

let Tools = {};

Tools.removeTab=function(componentName,autoSkip=true){
  let tab=store.state.system.tab
  let tab2=store.state.system.tab2

  let find=false
  tab.some((item,index)=>{
      if(item.meta&&item.meta.componentName==componentName){
        Tools.setExInclude(item,1)
        store.commit("system/setTabSplice", {index: index, count: 1});
        if (tab2.length > 0) {
          let deleteIndex=tab2.length-1
          store.commit("system/setTabPush", tab2[deleteIndex]);
          store.commit("system/setTab2Splice", {index: deleteIndex, count: 1});
        }
        if (autoSkip==true&item.active) {
          router.push(
            {
              path: tab[index - 1].path,
              query: tab[index - 1].query
            }
          );
        }
        find=true
        return true
      }
  })

  if(!find){
    tab2.some((item,index)=>{
      if(item.meta&&item.meta.componentName==componentName){
        Tools.setExInclude(item,1)
        store.commit("system/setTab2Splice", {index: index, count: 1});
        if (item.active) {
          if (index != 0) {
            router.push(
              {
                path: tab2[index - 1].path,
                query: tab2[index - 1].query
              }
            )
          } else {
            router.push(
              {
                path: tab[tab.length - 1].path,
                query: tab[tab.length - 1].query
              }
            )
          }
        }
        return true
      }
    })
  }

}

Tools.setExInclude=(tab, type)=>{
  if (tab.meta && tab.meta.componentName) {
    //设置为不缓存
    if (type == 1) {
      let e = store.state.system.exincludeList
      let a = false
      e.some((item) => {
        if (item == tab.meta.componentName) {
          a = true
          return true
        }
      })
      if (!a) {
        e.push(tab.meta.componentName)
        store.commit("system/setExincludeList", e);
      }
    } else {
      //设置为缓存
      let e = this.$store.state.system.exincludeList
      let newArray = e.filter((item) => {
        return item != tab.meta.componentName
      })
      this.$store.commit("system/setExincludeList", newArray);
    }
  }
}

Tools.numToCny = function (money) {
  // 汉字的数字
  let cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆',
    '柒', '捌', '玖');
  // 基本单位
  let cnIntRadice = new Array('', '拾', '佰', '仟');
  // 对应整数部分扩展单位
  let cnIntUnits = new Array('', '万', '亿', '兆');
  // 对应小数部分单位
  let cnDecUnits = new Array('角', '分', '毫', '厘');
  // 整数金额时后面跟的字符
  let cnInteger = '整';
  // 整型完以后的单位
  let cnIntLast = '元';
  // 最大处理的数字
  let maxNum = 999999999999999.9999;
  // 金额整数部分
  let integerNum;
  // 金额小数部分
  let decimalNum;
  // 输出的中文金额字符串
  let chineseStr = '';
  // 分离金额后用的数组，预定义
  let parts;
  if (money == '') {
    return '';
  }
  money = parseFloat(money);
  if (money >= maxNum) {
    // 超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  // 转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    let IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      let n = integerNum.substr(i, 1);
      let p = IntLen - i - 1;
      let q = p / 4;
      let m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        // 归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)]
          + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  // 小数部分
  if (decimalNum != '') {
    let decLen = decimalNum.length;
    for (let i = 0; i < decLen; i++) {
      let n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

Tools.str2Json = function (str) {
  if (!str) {
    return null;
  }
  var json = null;
  json = eval("(" + str + ")");
  return json;
}

Tools.enterConvert = function (fieldval, replaceQuotation) {
  if (fieldval) {
    fieldval = fieldval.replace(/\n/g, "@#n#@");
    if (replaceQuotation === false) {
      fieldval = fieldval.replace(/\"/g, "##");
    }
  }
  return fieldval;
}

Tools.formatDate = function (date) {
  if (!date) {
    return "";
  }
  date = date + ''
  return date.substring(0, 4) + "-" + date.substring(4, 6) + "-" + date.substring(6, 8);
}

Tools.formatDateTime = function (date, time) {
  if (!date || !time) {
    return "";
  }
  date = date + ''
  time = time + ''

  let result = date.substring(0, 4) + "-" + date.substring(4, 6) + "-" + date.substring(6, 8) + " ";
  if (time.length == 6) {
    return result + time.substring(0, 2) + ":" + time.substring(2, 4) + ":" + time.substring(4, 6);
  } else {
    return result + time.substring(0, 2) + ":" + time.substring(2, 4);
  }
}

Tools.diffDateTime = function (date1, time1, date2, time2) {
  let moment1 = moment(date1 + ' ' + time1);
  let moment2 = moment(date2 + ' ' + time2);

  let time = moment2.diff(moment1, 'second');
  let day = Math.floor(time / 86400);
  time = time % 86400;

  let hour = Math.floor(time / 3600);
  time = time % 3600;

  let minute = Math.floor(time / 60);
  time = time % 60;

  let second = time;

  return day + '天' + hour + '时' + minute + '分' + second + '秒';
}

Tools.formatTime = function (time) {
  if (!time) {
    return "";
  }
  time = time + ''
  return time.substring(0, 2) + ":" + time.substring(2, 4);
}

function formatMoney(s) {
  let dot = ','
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
  var l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  t = "";
  for (i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? dot : "");
  }
  return t.split("").reverse().join("") + "." + r;
}

Tools.formatMoney = function formatMoney(s) {
  if (!s) {
    return ""
  }
  let dot = ','
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(2) + "";
  let l = s.split(".")[0].split("").reverse(),
    r = s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? dot : "");
  }
  return t.split("").reverse().join("") + "." + r;
}

Tools.apply = function (o, c) {
  if (o == null) {
    o = {};
  }
  if (o && c && typeof c == 'object') {
    for (var p in c) {
      o[p] = c[p];
    }
  }
  return o;
};


/**
 * 将数组转换成字符串
 */
Tools.array2str = function (arr, includeFunction) {
  if (arr == null) {
    return 'null';
  }
  var s = [],
    v, type;
  for (var i = 0; i < arr.length; i++) {
    v = arr[i], type = (typeof v);
    switch (type) {
      case 'function': //function对象不添加
        if (includeFunction === true) {
          v = '"' + String(v).replace(/[\n\r\t]/g, '').replace(/[\t]/g, ' ') + '"';
        } else {
          continue;
        }
        break;
      case 'string': //字符串添加双引号
        v = '"' + v + '"';
        break;
      case 'object':
        if (Tools.isArray(v)) {
          v = Tools.array2str(v, includeFunction);
        } else {
          v = Tools.json2str(v, includeFunction);
        }
        break;
    }
    s.push(v);
  }
  return '[' + s.join(',') + ']';
};

/**
 * 将JSON对象转换成字符串
 * 参数：includeFunction boolean类型，true则包含function值的属性也转成string，其他值则不转function属性，默认为false
 */
Tools.json2str = function (json, includeFunction, isConfOption) {
  if (json == null) {
    return 'null';
  }
  if (Tools.isArray(json)) {
    return Tools.array2str(json, includeFunction, isConfOption);
  }
  var s = [],
    k, v, type;
  for (k in json) {
    v = json[k], type = (typeof v);
    switch (type) {
      case 'function': //function对象不添加
        if (includeFunction === true) {
          //避免出现脚本错误，需要把一些特殊字符做替换
          v = String(v).replace(new RegExp('\/\/.*[\n\r]', 'g'), ' ') // 需要将单行注释给替换掉
            //换行和制表符
            .replace(new RegExp('[\n\r]', 'g'), '').replace(new RegExp('[\t]', 'g'), ' ');
          if (isConfOption === true) { //在confOption里
          } else {
            v = '"' + v + '"';
          }
        } else {
          continue;
        }
        break;
      case 'string': //字符串添加双引号
        var reg = new RegExp('"', "g"); //创建正则RegExp对象
        v = v.replace(reg, '\\"');
        v = '"' + v + '"';
        break;
      case 'object':
        if (Tools.isArray(v)) {
          v = Tools.array2str(v, includeFunction, isConfOption);
        } else {
          if (k == 'confOption') {
            v = '"' + Tools.json2str(v, includeFunction, true).replace(/["]/g, '\\"') + '"';
          } else {
            v = Tools.json2str(v, includeFunction, isConfOption);
          }
        }
        break;
    }
    s.push('"' + k + '":' + v);
  }
  return '{' + s.join(', ') + '}';
};

/**
 * 判断对象是否数组
 */
Tools.isArray = function (object) {
  if (object == null) {
    return false;
  }
  return object != null && typeof object == "object" &&
    object.splice != null && object.join != null && object.length != null;
};


Tools.downloadFileByParams = function (download_path, download_name, download_code) {
  $("#downloadForm").remove();
  var downloadFormHtml =
    '<form id="downloadForm" action="base/comn-download.action" method="post" class="k-hidden" target="_self">';
  downloadFormHtml += '<input type="text" name="download_path" value=' + download_path + ' />';
  downloadFormHtml += '<input type="text" name="download_name" value=' + download_name + ' />';
  downloadFormHtml += '<input type="text" name="download_code" value=' + download_code + ' />';
  downloadFormHtml += '</form>';

  var $downloadForm = $(downloadFormHtml);
  $downloadForm.appendTo($("body"));
  $downloadForm.submit();
}


Tools.download = function (path, filename) {
  httpUtil
    .download({
      url: "/base/comn-download.json",
      params: {"path": path}
    }, filename)
}

Tools.batch_download = function (paths, filename) {
  httpUtil
    .download({
      url: "/base/comn-batch-download.json",
      params: {"paths": paths}
    }, filename)
}

Tools.alert = function (message, type = global.notify_type.success, icon = "add_alert", horizontalAlign = "center", verticalAlign = "top") {
  kayak.app.$notify({
    timeout: 2500,
    message: message,
    icon: icon,
    horizontalAlign: horizontalAlign,
    verticalAlign: verticalAlign,
    type: type
  });
}

Tools.confirm = function (callback, message, title, type, confirmButtonText, cancelButtonText, buttonClass) {
  let dataDescribe = message ? message : '确定执行该操作吗？'
  MessageBox.confirm(dataDescribe, title ? title : '操作提示', {
    confirmButtonText: confirmButtonText ? confirmButtonText : '确定',
    cancelButtonText: cancelButtonText ? cancelButtonText : '取消',
    cancelButtonClass: buttonClass ? buttonClass : 'el-button--info',
    type: type ? type : 'warning',
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true;
        instance.confirmButtonText = '执行中...';

        callback();
        done();
        instance.confirmButtonLoading = false;
      } else {
        done();
      }
    }
  }).catch(() => {
  });
}

Tools.getLoginUser = function () {
  return new Promise((resolve, reject) => {
    if (!Tools.loginUser) {
      httpUtil.ajax({
        url: 'getLoginUser.json',
        dataAfterSuccess: function (json) {
          Tools.loginUser = json.returndata;
          resolve(Tools.loginUser);
        }
      });
    } else {
      resolve(Tools.loginUser);
    }
  });
}

Tools.ssoOutLogin = function () {
  const outUrl = localStorage.getItem("outUrl");
  if(outUrl) {
    window.location.href = outUrl;
  } else {
    router.push({
      path: "/login"
    });
  }
}

/**
 * 计算字符串字节长度(汉字两个字节)
 * @param str 目标字符串
 * @returns {number} 字节长度
 */
Tools.strByteLength = function (str) {  //获取字符串的字节数，扩展string类型方法
  if (!str || str.length == 0) {
    return 0;
  }
  let b = 0;
  let l = str.length;  //初始化字节数递加变量并获取字符串参数的字符个数
  for (let i = 0; i < l; i++) {  //遍历字符串，枚举每个字符
    if (str.charCodeAt(i) > 255) {  //字符编码大于255，说明是双字节字符
      b += 2;  //则累加2个
    } else {
      b++;  //否则递加一次
    }
  }
  return b;  //返回字节数
}


/**
 * 递归深度合并两个json
 * 遇到相同元素级属性，以后者（main）为准
 * 不返回新Object，而是main改变
 */
Tools.mergeJSON = function (minor, main) {
  for (var key in minor) {
    if (main[key] === undefined) {  // 不冲突的，直接赋值
      main[key] = minor[key];
      continue;
    }
    // 冲突了，如果是Object，看看有么有不冲突的属性
    // 不是Object 则以main为主，忽略即可。故不需要else
    if (Tools.isJSON(minor[key])) {
      // arguments.callee 递归调用，并且与函数名解耦
      Tools.mergeJSON(minor[key], main[key]);
    }
  }
}

Tools.isJSON = function (target) {
  return typeof target == "object" && target.constructor == Object;
}

Tools.getNowTime = function () {
  return moment().format('YYYYMMDDhhmmss')
}

/**
 * 路由跳转传参封装
 *
 * @param target 目标页面，可以是path也可以是componentName
 * @param parameter 目标参数
 */
Tools.router = function (target ,parameter = {}) {
  function search(list) {
    list.forEach(val => {
      if(val.children){
        search(val.children)
      }
      if(val.meta && val.meta.componentName === target) {
        router.push({
          name: val.name,
          params: parameter
        })
      }
    })
  }
  let childList = [];
  if(target.match(new RegExp('/'))) {
    router.push({
      path: target,
      query: parameter
    })
  } else {
    for (let route of router.options.routes) {
      Object.keys(route).forEach(key => {
        if(key === "name" && route[key] === target) {
          router.push({
            name: target,
            params: parameter
          })
        } else {
          if(key === "children") {
            childList = route[key]
          }
        }
      })
    }
    search(childList)
  }
}
export default Tools;



// WEBPACK FOOTER //
// ./src/utils/tools.js